import { BuilderDataWithSelectorProps } from 'src/containers/formBuilder/formTypeProvider';
import { useStudyNotesConfigPanel } from '../configPanel/useStudyNotesConfigPanel';
import { EMPTY_LAYOUT } from 'src/containers/formBuilder/formBuilder';
import { SerializedNodes } from '@craftjs/core';
import { useStudyNoteSelector } from './useStudyNoteSelector';
import { useStudyNoteHandlers } from './useStudyNoteHandlers';

export const useStudyNoteBuilderProps = (options?: { enabled?: boolean }): BuilderDataWithSelectorProps => {
  const selector = useStudyNoteSelector(options);
  const panel = useStudyNotesConfigPanel({ initialTitle: selector.selectedConfig?.title });
  const handlers = useStudyNoteHandlers({
    selectedConfigId: selector.selectedConfig?.id,
    setConfigId: selector.setConfigId,
    initialTitle: panel.title,
  });

  return {
    builderProps: {
      ...handlers.builderProps,
      defaultLayout: (selector.formConfigQuery.data?.layout ?? EMPTY_LAYOUT) as SerializedNodes,
      initialScoreSections: selector.formConfigQuery.data?.scoreSections ?? [],
      initialVariables: selector.formConfigQuery.data?.variables ?? [],
      loading: selector.formConfigQuery.isInitialLoading,
      formConfigSettingPanel: panel.panelComponent,
    },
    selectorProps: selector.selectorProps,
    createConfigModal: handlers.createConfigModal,
  };
};
